import { render, staticRenderFns } from "./formDivide.vue?vue&type=template&id=1f0ae14a&scoped=true&"
import script from "./formDivide.vue?vue&type=script&lang=js&"
export * from "./formDivide.vue?vue&type=script&lang=js&"
import style0 from "./formDivide.vue?vue&type=style&index=0&id=1f0ae14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ae14a",
  null
  
)

export default component.exports